import React from 'react'
import { CaretDownOutlined } from '@ant-design/icons';
import { Button, DatePicker, Select, Tooltip } from "antd";
import moment from 'moment';
import Util from "../../public/utils";
import Message from "../ant/Message";
import styles from './style/index.less'
/**
 * props
 * itemList:查询条件组件
 * className:容器的样式
 * onChange：查询条件变化时回调
 * linkage：是否联动，ture时没有按钮组显示，false时显示按钮组
 * onOkText：筛选按钮文本
 * onResetText：重置按钮文本
 * otherBtns：自定义按钮，跟在按钮组后面，ReactNode
 * @type {React.ClassicComponentClass<OptionProps>}
 */
// itemList示例
// let searchItemList = [
//     {
//         id: 'activityList',  //id唯一，必填
//         labelText: '当前活动',
//         itemType: ItemType.Select,
//         data: {
//             optionList: [
//                 {
//                     name: '测试1',
//                     id: 1
//                 },
//                 {
//                     name: '测试2',
//                     id: 2
//                 }
//             ], //下拉选项数据
//             optionKey: 'name', //下拉显示文本的key
//             valueKey: 'id',    //下拉value的key
//         },
//         style: {
//             minWidth: 200  //自定义样式
//         }
//     },
//     {
//         id: 'timeRange', ////id唯一，必填
//         labelText: '统计时间',
//         itemType: ItemType.TimeDaySelect,
//         data: {
//             days: [
//                 {
//                     day: -1,
//                     name: '今天'
//                 },
//                 {
//                     day: -2,
//                     name: '昨天'
//                 },
//                 {
//                     day: 7,
//                     name: '近7天'
//                 },
//                 {
//                     day: 30,
//                     name: '近30天'
//                 },
//                 {
//                     day: 0,
//                     name: '自定义'
//                 }
//             ], //days格式固定，day：-1今天，-2昨天，0自定义 7是近7天
//             defaultValue: {
//                 day: -1
//             }
//         }
//     }
// ];
const dateFormat = 'YYYY/MM/DD';
const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;
const selectDefaultStyle = {
    minWidth: 120
};

const timeDaySelectRangePickerDefaultStyle = {
    width: 240
};

const timeDaySelectStyle = {
    width: 200
};

class SearchItems extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
        this.setItemList = this.setItemList.bind(this);
        this.setQueryParams = this.setQueryParams.bind(this);
    }

    componentDidMount() {
        this.setItemList(this.props.itemList)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (JSON.stringify(this.props.itemList) != JSON.stringify(nextProps.itemList)) {
            this.setItemList(nextProps.itemList);
        }
    }

    setItemList(itemList) {
        if (itemList) {
            let queryParams = {};
            itemList.forEach((item, index) => {
                let itemType = item.itemType;
                if (itemType == ItemType.Select) {
                    let dv = null;
                    if (item.data.defaultValue) {
                        //设置了默认值
                        dv = item.data.defaultValue
                    } else if (item.data.optionList && item.data.optionList.length > 0) {
                        //使用第一个值
                        dv = item.data.optionList[0];
                        if (item.data.valueKey) {
                            dv = dv[item.data.valueKey];
                        }
                    }
                    queryParams[item.id] = dv
                } else if (itemType == ItemType.TimeDaySelect) {
                    let dv = null;
                    if (item.data.defaultValue) {
                        //设置了默认值
                        dv = {
                            day: item.data.defaultValue.day
                        };
                    } else if (item.data.days && item.data.days.length > 0) {
                        dv = {
                            day: item.data.days[0].day
                        }
                    }
                    if (dv && dv.day != 0) {
                        let range = this.getTimeRange(dv.day)
                        if (dv.day > 0) {
                            dv.beginDate = range[0].valueOf();
                            dv.endDate = range[1].valueOf();
                        } else {
                            dv.beginDate = range[0].valueOf();
                        }
                    }
                    queryParams[item.id] = dv;
                }
            });
            this.setState({
                itemList: itemList,
                queryParams: queryParams
            });
        }
    }

    /**
     * 设置查询条件
     * @param queryParams
     */
    setQueryParams(queryParams) {
        this.setState({
            queryParams: queryParams
        })
    }

    /**
     * 下拉框变化回调
     * @param index
     * @param val
     */
    selectChange(index, val) {
        let itemList = this.state.itemList;
        let queryParams = this.state.queryParams;
        let item = itemList[index];
        queryParams[item.id] = val;
        this.setQueryParams(queryParams);
        if (this.props.type) { // 分销数据分析 渠道根据 活动改变
            this.props.onChange(queryParams);
        }
        if (this.props.linkage && this.props.onChange) {
            this.props.onChange(queryParams);
        }
    }

    timeDaySelectChange(index, val) {
        let itemList = this.state.itemList;
        let queryParams = this.state.queryParams;
        let item = itemList[index];
        let params = {};
        params.day = val;
        if (val < 0) {
            params.beginDate = this.getTimeRange(val)[0].valueOf();
        } else if (val > 0) {
            let range = this.getTimeRange(val);
            params.beginDate = range[0].valueOf();
            params.endDate = range[1].valueOf();
        }
        queryParams[item.id] = params;
        this.setQueryParams(queryParams);
        if (val != 0 && this.props.linkage && this.props.onChange) {
            this.props.onChange(queryParams);
        }
    }

    timeDaySelectRangeChange(index, val) {
        let itemList = this.state.itemList;
        let queryParams = this.state.queryParams;
        let item = itemList[index];
        let params = {};
        params.day = 0;
        params.beginDate = val[0].valueOf();
        params.endDate = val[1].valueOf();
        let time =val[1].valueOf()-val[0].valueOf()
        if(time/(24 * 3600 * 1000)>90){
           Message.warning('选择时间最大跨度不能超过90天')
            return false
        }

            this.setQueryParams(queryParams);
            if (this.props.linkage && this.props.onChange) {
                this.props.onChange(queryParams);
            }
        queryParams[item.id] = params;
    }

    getTimeRange(day) {
        let dateformat = 'yyyy-MM-dd';
        let range = [];
        if (day == -1) {
            //今天
            range.push(moment(new Date().format(dateformat), dateFormat))
        } else if (day == -2) {
            //昨天
            let now = new Date();
            now.setDate(now.getDate() - 1);
            range.push(moment(now.format(dateformat), dateFormat))
        } else if (day > 0) {
            let now = new Date();
            range.push(moment(now.format(dateformat), dateFormat));
            now.setDate(now.getDate() - day);
            range.unshift(moment(now.format(dateformat), dateFormat))
        }
        return range;
    }

    query() {
        if(this.state.queryParams.timeRange>0){
            if((this.state.queryParams.timeRange.endDate-this.state.queryParams.timeRange.beginDate)/(24 * 3600 * 1000)<=90){
                if (this.props.onChange) {
                    this.props.onChange(this.state.queryParams);
                } else{
                    Message.warning('时间跨度不能超过90天')
                    return false
                }
            }
        }
        else{
            if (this.props.onChange) {
                this.props.onChange(this.state.queryParams);
            }
        }


    }

    reset() {
        this.setItemList(this.state.itemList)
        setTimeout(()=>{
            if (this.props.onChange) {
                this.props.onChange(this.state.queryParams);
            }
            },10
        )
    }

    render() {
        return (
            <ul className={`searchItemsWraper ${this.props.className ? this.props.className : ''}`}>
                {
                    this.state.itemList && this.state.itemList.length > 0 ? this.state.itemList.map((item, index) => {
                        return (
                            <li className={'searchItem'} key={index}>
                                {
                                    item.labelText ? <label>{item.labelText}：</label> : ''
                                }
                                {
                                    item.itemType == ItemType.Select ?
                                        <span onMouseOver={Util.disableScroll} onMouseOut={Util.enableScroll}>
                                            <Select style={{minWidth: 200}}
                                                    value={this.state.queryParams[item.id]}
                                                    suffixIcon={<CaretDownOutlined />}
                                                    // style={item.style ? item.style : selectDefaultStyle}
                                                    onChange={this.selectChange.bind(this, index)}
                                                    getPopupContainer={triggerNode => triggerNode.parentNode}>
                                            {
                                                item.data.optionList && item.data.optionList.map((data, index) => {
                                                    return (
                                                        <Option key={index}
                                                                value={item.data.valueKey ? data[item.data.valueKey] : index}>
                                                            {
                                                                item.data.optionKey ? data[item.data.optionKey] : data
                                                            }
                                                        </Option>
                                                    )
                                                })
                                            }
                                            </Select>
                                        </span>
                                         : item.itemType == ItemType.TimeDaySelect ?
                                        <ul className='searchTimeDay'>
                                            <li className='searchTimeDayItems'>
                                                <Select
                                                    style={{minWidth: 200, maxWidth: 250}}
                                                    value={this.state.queryParams[item.id].day}
                                                    suffixIcon={<CaretDownOutlined />}
                                                    // style={timeDaySelectStyle}
                                                    onChange={this.timeDaySelectChange.bind(this, index)}
                                                    getPopupContainer={triggerNode => triggerNode.parentNode}>
                                                    {
                                                        item.data.days && item.data.days.map((data, index) => {
                                                            return (
                                                                <Option key={index}
                                                                        value={data['day']}>
                                                                    {
                                                                        data['name']
                                                                    }
                                                                </Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </li>
                                            <li className='searchTimeDayItems'>
                                                {
                                                    this.state.queryParams[item.id].day >= 0 ? <RangePicker
                                                            style={{minWidth: 200, maxWidth: 250}}
                                                            disabled={this.state.queryParams[item.id].day > 0 ? true : false}
                                                            // style={timeDaySelectRangePickerDefaultStyle}
                                                            value={this.state.queryParams[item.id].day == 0 ? this.state.queryParams[item.id].beginDate && this.state.queryParams[item.id].endDate ? [moment(this.state.queryParams[item.id].beginDate), moment(this.state.queryParams[item.id].endDate)] : null : this.getTimeRange(this.state.queryParams[item.id].day)}
                                                            onChange={this.timeDaySelectRangeChange.bind(this, index)}
                                                            getPopupContainer={triggerNode => triggerNode.parentNode}/> :
                                                        <DatePicker disabled={true}
                                                                    style={{minWidth: 200}}
                                                                    value={this.getTimeRange(this.state.queryParams[item.id].day)[0]}
                                                                    dateFormat={dateFormat}
                                                                    />
                                                }
                                            </li>
                                        </ul> : ''
                                }
                            </li>
                        );
                    }) : ''
                }
                {
                    <li  className={this.props.bthClassName ? this.props.bthClassName+ ' qySearchTooltip' : 'searchItem qySearchTooltip'}>
                        <span className='searchBtn' style={{marginTop:'5px',display:'block'}}>
                            <Tooltip title={'支持筛选3个月的数据，最长跨度不能超过90天'}><i className="icon-question"></i></Tooltip>
                        </span>
                    </li>
                }
                {
                    this.props.linkage ? '' :
                        <li className={this.props.bthClassName ? this.props.bthClassName : 'searchItem '}>
                            <span className={'searchBtn'}>
                                <Button onClick={this.query.bind(this)}
                                        type='primary'>{this.props.onOkText ? this.props.onOkText : '筛选'}</Button>
                            </span>
                            <span className={'searchBtn'}>
                                <Button className={'reset'}
                                    onClick={this.reset.bind(this)}>{this.props.onResetText ? this.props.onResetText : '重置'}</Button>
                            </span>
                        </li>
                }
                {
                    this.props.otherBtns?
                        <li className={this.props.bthClassName ? this.props.bthClassName : 'searchItem'}>
                    <span className={'searchBtn'}>
                                {
                                    this.props.otherBtns
                                }
                            </span>
                        </li>:''
                }

                <span className='clearfix'></span>

            </ul>
        );
    }
}

export default SearchItems

const ItemType =
    {
        Select: 'Select', //下拉框
        TimeDaySelect: 'TimeDaySelect'
    };
export {ItemType}